import { call, put } from "redux-saga/effects";
import { getGroupsAction } from "../../actions";
import { deleteAsync } from "../commonAsync";
import {toggleAlert, toggleAlertActionCreator, toggleLoading} from '../../slices'

export function* deleteGroupSaga(action) {
  try {
    yield put(toggleLoading(true))
    const response = yield call(deleteAsync, `groups/${action.payload.groupId}`)
    if (yield response.ok) {
      yield put(toggleAlert(toggleAlertActionCreator('success', `Group deleted successfully`)))
      yield put(getGroupsAction(25, 1, true))
    }
    else {
      const errorCode = yield response.status;
      const { Error } = yield response.json();
      const errorMessages = yield Error?.map(error => error?.message).join(",")
      yield put(toggleAlert(toggleAlertActionCreator('error', `${errorCode}: ${errorMessages}`)))
    }
    yield put(toggleLoading(false))
  }
  catch (error) {
    yield put(toggleAlert(toggleAlertActionCreator('error', error?.toString())))
  }
}
